<template>
  <div class="page">
    <div class="container text-center">
      <div class="avatar avatar-xlg" :style="{ backgroundImage: `url(${user.avatar})` }">
        <button class="btn"><i class='bx bx-camera'></i></button>
      </div>
      <h1 class="mt-4">Personal information</h1>
    </div>
    <div class="text-center">
      <a href="#" @click="onOpenEdit()" v-if="!edit"><i class="fa fa-edit"></i> Edit profile</a>
    </div>
    <div class="container mt-4" v-if="!edit">
      <div class="card">
        <div class="card-header">
          <h3>Basic information</h3>
        </div>
        <div class="card-body">
          <div class="d-flex">
            <div><label for="">Display name</label></div>
            <div>{{ user.displayName }}</div>
          </div>
          <div class="d-flex mt-2">
            <div><label for="">Gender</label></div>
            <div :class="{ unset: !user.gender }">{{ user.gender || 'Unset' }}</div>
          </div>
          <div class="d-flex mt-2">
            <div><label for="">Birthday</label></div>
            <div :class="{ unset: !user.birthday }">{{ user.birthday ? $filters.shortDate(user.birthday) : 'Unset' }}</div>
          </div>
        </div>
      </div>

      <div class="card mt-4">
        <div class="card-header">
          <h3>Account information</h3>
        </div>
        <div class="card-body">
          <div class="d-flex">
            <div><label for="">Username</label></div>
            <div><span class="text-secondary">@</span>{{ user.loginValues[0] }}</div>
          </div>
          <div class="d-flex mt-2">
            <div><label for="">Email</label></div>
            <div>{{ user.email }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-4" v-else>
      <div class="card">
        <div class="card-header">
          <h3>Basic information</h3>
        </div>
        <div class="card-body">
          <div class="d-flex">
            <div><label for="">Display name</label></div>
            <div><input class="form-control" type="text" v-model="edit.displayName" :class="{ 'border-danger': editErrors.displayName }" />
            <div class="msg-error" v-if="editErrors.displayName">{{ editErrors.displayName }}</div></div>
          </div>
          <div class="d-flex mt-2">
            <div><label for="">Gender</label></div>
            <div>
              <select class="form-control" v-model="edit.gender">
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>
          <div class="d-flex mt-2">
            <div><label for="">Birthday</label></div>
            <div><input class="form-control" type="date" v-model="edit.birthday" :class="{ 'border-danger': editErrors.birthday }" />
            <div class="msg-error" v-if="editErrors.birthday">{{ editErrors.birthday }}</div></div>
          </div>
        </div>
      </div>

      <div class="card mt-4">
        <div class="card-header">
          <h3>Account information</h3>
        </div>
        <div class="card-body">
          <div class="d-flex">
            <div><label for="">Username</label></div>
            <div><input class="form-control" type="text" v-model="edit.loginValue" :class="{ 'border-danger': editErrors.loginValue }" />
            <div class="msg-error" v-if="editErrors.loginValue">{{ editErrors.loginValue }}</div></div>
          </div>
          <div class="d-flex mt-2">
            <div><label for="">Email</label></div>
            <div><input class="form-control" type="text" v-model="edit.email" :class="{ 'border-danger': editErrors.email }" />
            <div class="msg-error" v-if="editErrors.email">{{ editErrors.email }}</div></div>
          </div>
        </div>
      </div>

      <div class="text-center mt-4">
        <button class="btn btn-secondary" @click="edit = null">Cancel</button>
        <button class="btn btn-success" style="margin-left: 10px; width: 100px;" @click="onSaveProfile()">
          <div v-if="isSaving" class="spinner-border spinner-border-sm" role="status">
            <span class="sr-only"></span>
          </div> Save
        </button>
      </div>
    </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      isSaving: false,
      edit: null,
      editErrors: {}
    }
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },

  methods: {
    onOpenEdit() {
      this.edit = {
        email: this.user.email,
        gender: this.user.gender,
        birthday: this.user.birthday,
        displayName: this.user.displayName,
        loginValue: this.user.loginValues[0]
      };
      this.editErrors = {};
    },

    async onSaveProfile() {
      this.isSaving = true;
      let res = await this.$aloop.account.auth.updateProfile(this.edit).call();
      this.isSaving = false;

      if (res.success) {
        this.$store.commit('auth/update', {user: res.response});
        this.$store.dispatch('toast/show', {
          data: {message: 'Save profile successfully'},
          variant: 'success',
          delay: 2000
        });
        this.edit = null;
      } else {
        this.editErrors = res.response.errors;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding-top: 90px;
  width: 900px;
  max-width: 100%;
  margin: 0 auto;
}

h1 {
  font-size: 1.2rem;
}

.unset {
  font-style: italic;
  color: var(--color-body-text-hover);
  font-size: 0.8rem;
}

h3{
  font-size: 1.2rem;
}
.card-body {
  >.d-flex {
    >div {
      &:last-child {
        flex: 1;
      }

      &:first-child {
        width: 30%;

        label {
          color: var(--color-body-text-hover);
        }
      }
    }
  }
}

.avatar{
  display: inline-flex;
  overflow: hidden;

  .btn{
    background-color: rgba(255,255,255,0.1);
    color: #fff;
    flex: 1;
    outline: none;
    border: none;
  }
}
</style>
